"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCampaignSpendDetailsResponseSchema = exports.GetCampaignSpendDetailsQuerySchema = exports.UpliftBudgetInCampaignResponseSchema = exports.UpliftBudgetInCampaignBodySchema = exports.UpliftBudgetCampaignDetailsSchema = exports.UpliftBudgetInRegionResponseSchema = exports.UpliftBudgetInRegionBodySchema = exports.UpliftBudgetRegionDetailsSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
// Region
exports.UpliftBudgetRegionDetailsSchema = (0, core_1.StrictObject)({
    budgetUplift: core_1.MoneySchema,
    dailySpendLimit: core_1.MoneySchema,
    purpose: ruby_1.PurposeSchema,
    country: core_1.CountrySchema,
});
exports.UpliftBudgetInRegionBodySchema = (0, core_1.StrictObject)({
    regions: typebox_1.Type.Array(exports.UpliftBudgetRegionDetailsSchema),
});
exports.UpliftBudgetInRegionResponseSchema = (0, core_1.StrictObject)({
    campaignId: core_1.IdSchema,
    regions: typebox_1.Type.Array(exports.UpliftBudgetRegionDetailsSchema),
});
// Campaigns
exports.UpliftBudgetCampaignDetailsSchema = (0, core_1.StrictObject)({
    budgetUplift: core_1.MoneySchema,
    dailySpendLimit: core_1.MoneySchema,
    campaignRef: ruby_1.AppleProxyRefSchema,
});
exports.UpliftBudgetInCampaignBodySchema = (0, core_1.StrictObject)({
    campaigns: typebox_1.Type.Array(exports.UpliftBudgetCampaignDetailsSchema),
});
exports.UpliftBudgetInCampaignResponseSchema = (0, core_1.StrictObject)({
    campaignId: core_1.IdSchema,
    campaigns: typebox_1.Type.Array(exports.UpliftBudgetCampaignDetailsSchema),
});
exports.GetCampaignSpendDetailsQuerySchema = (0, core_1.StrictObject)({
    campaignRef: ruby_1.AppleProxyRefSchema,
    from: core_1.TimestampSchema,
    to: core_1.TimestampSchema,
});
exports.GetCampaignSpendDetailsResponseSchema = (0, core_1.StrictObject)({
    spent: core_1.MoneySchema,
    uplifted: core_1.MoneySchema,
    unspent: core_1.MoneySchema,
});
